export const blockIconsAudioandvideoMicOff = (
	<span className='material-symbols-outlined'>mic_off</span>
);
